module.exports = __webpack_public_path__ + "img/15.e482bc0a.jpg";